export const ROUTES = {
  LOGIN: "/login",
  SIGNALS: "/",
  TERMINAL_ANALYTICS: "/terminal-analytics",
  TERMINAL_ACCOUNTS: "/terminal-accounts",
  NEW_ACCOUNT: "/terminal-accounts/new",
  ACCOUNT_DETAIL: "/terminal-accounts/:id",
  MERCHANTS: "/merchants",
  MERCHANT_DETAIL: "/merchants/:businessId",
  MERCHANT_TIMELINE: "/merchants/:businessId/timeline",
  SUPPORT: "/support",
  TRANSACTION_DETAIL: "/merchants/:businessId/transactions/:txId",
  TERMINAL_ACCOUNT_TRANSACTION_DETAIL:
    "/terminal-accounts/:id/transactions/:txId",
  MARKETING_REFERRALS: "/marketing/referrals",
  MARKETING_ACTIVATION_BONUS: "/marketing/activation-bonus",
  ASSISTANT_GAPS: "/assistant-gaps",
  EVENTS: "/events",
  EVENT_DETAIL: "/events/:source/:id",
  TOOLS: "/tools",
  CREATE_MERCHANT: "/tools/create-merchant",
  TOOL_HISTORY: "/tools/:toolId/history",
  ADMINS: "/admins",
  PLAY_HOOPS: "/play/cpos-hoops",
} as const;

/**
 * Run-history route for a tool, by its own id.
 *
 * Keyed by tool rather than job type because two tools can enqueue the same
 * type — the entry-mode pair runs `reconcile` jobs just as Repair Database
 * does — and keying by type made whichever registered first swallow the others.
 */
export function toolHistoryPath(toolId: string): string {
  return ROUTES.TOOL_HISTORY.replace(":toolId", encodeURIComponent(toolId));
}

/** The merchant detail page for one business. */
export function merchantPath(businessId: string): string {
  return ROUTES.MERCHANT_DETAIL.replace(":businessId", businessId);
}

/** A merchant's detail page, opened on a given tab. */
export function merchantTabPath(businessId: string, tab: string): string {
  return `${merchantPath(businessId)}?tab=${encodeURIComponent(tab)}`;
}

/** One merchant's full action timeline. */
export function merchantTimelinePath(businessId: string): string {
  return ROUTES.MERCHANT_TIMELINE.replace(":businessId", businessId);
}

/** Support tickets, optionally narrowed to one merchant. */
export function supportPath(businessId?: string): string {
  return businessId
    ? `${ROUTES.SUPPORT}?businessId=${encodeURIComponent(businessId)}`
    : ROUTES.SUPPORT;
}
